import { appointableQueryKeys } from "@gymflow/api";
import { ApiListResponse, AppointableCategoryDTO } from "@gymflow/types";
import { InfiniteData, infiniteQueryOptions } from "@tanstack/react-query";
import {
  FormSelectInput,
  SettingsIcon,
} from "apps/portal/src/components/atoms";
import { ModalContext } from "apps/portal/src/providers";
import useGymflowModels from "apps/portal/src/store";
import { useContext } from "react";
import { useTranslation } from "react-i18next";

import { AppointableFormValues } from "../../../types";
import { AppointmentCategoriesModal } from "./AppointmentCategoriesModal";

export const FormCategorySelect = () => {
  const { t } = useTranslation();
  const { api } = useGymflowModels();
  const { setModal, hide } = useContext(ModalContext);

  return (
    <FormSelectInput<AppointableFormValues, number>
      name="details.category"
      label={t(
        "page.settings.tab.appointments.appointableWizard.appointableWizardDetailsForm.category.label",
      )}
      containerClassName="flex-1"
      isMulti={false}
      isRequired
      listButton={{
        title: t(
          "page.settings.tab.appointments.appointableWizard.appointableWizardDetailsForm.category.listButton.title",
        ),
        icon: (
          <SettingsIcon className="size-5" pathClassName="stroke-gray-500" />
        ),
        onClick: () =>
          setModal(<AppointmentCategoriesModal onHide={() => hide()} />),
      }}
      dataFetchingQuery={() =>
        infiniteQueryOptions({
          queryKey: appointableQueryKeys.categories({
            statusList: ["ACTIVE"],
            size: 10,
          }),
          queryFn: async ({ pageParam }) =>
            (
              await api.appointableApi.fetchCategories({
                size: 10,
                page: pageParam,
                statusList: ["ACTIVE"],
              })
            ).data,
          select: (data) => {
            const { pageParams, pages } = data as InfiniteData<
              ApiListResponse<AppointableCategoryDTO>
            >;

            const transformedPages = pages.map((page) =>
              page.content.map(({ id, name }) => ({
                id,
                label: name,
                value: id,
              })),
            );

            return {
              pageParams,
              pages: transformedPages,
            };
          },
          initialPageParam: undefined,
          getNextPageParam: (
            lastPage: ApiListResponse<AppointableCategoryDTO>,
          ) => {
            if (lastPage.last) {
              return undefined;
            }
            return lastPage.number + 1;
          },
        })
      }
    />
  );
};
